import { render, staticRenderFns } from "./FeaturedNewsSection.vue?vue&type=template&id=338e432c&"
import script from "./FeaturedNewsSection.vue?vue&type=script&lang=js&"
export * from "./FeaturedNewsSection.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedNewsSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports